import { message } from 'antd';
import { types } from '../types';
import device from '../requests/DeviceRequest';
import DeviceAction from '../actions/DeviceAction';
import { takeLatest, call, put } from 'redux-saga/effects';

export function* listDeviceSaga() {
  try {
    const deviceSagaSuccess = yield call(device.getDeviceList);
    if (deviceSagaSuccess.statusCode === 400) {
      message.error(deviceSagaSuccess.message);
    } else {
      yield put(DeviceAction.getAllDeviceListSuccess(deviceSagaSuccess));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* listDeviceCMSaga() {
  const deviceSagaSuccess = yield call(device.getDeviceCMList);
  if (deviceSagaSuccess.statusCode === 400) {
    message.error(deviceSagaSuccess.message);
  } else {
    yield put(DeviceAction.getAllDeviceListCMSuccess(deviceSagaSuccess));
  }
}

export function* createDeviceSaga(payload) {
  const deviceSagaSuccess = yield call(device.createDevice, payload.payload);
  if (deviceSagaSuccess.statusCode === 400) {
    message.error(deviceSagaSuccess.message);
  } else {
    message.success('Device saved successfully');
  }
}

export function* updateDeviceSaga(payload) {
  const deviceSagaSuccess = yield call(device.updateDevice, payload.payload);
  if (deviceSagaSuccess.statusCode === 400) {
    message.error(deviceSagaSuccess.message);
  } else {
    message.success('Device updated successfully');
  }
}

export function* deleteDeviceSaga(payload) {
  const deviceSagaSuccess = yield call(device.deleteDeviceSaga, payload.deviceId);
  if (deviceSagaSuccess.status === 204) {
    message.success('Device Deleted successfully');
    yield put(DeviceAction.deleteDevice());
  } else {
    message.error(deviceSagaSuccess.message);
  }
}

export function* listTagReferenceSaga() {
  const tagReferenceSagaSuccess = yield call(device.getList);
  yield put(DeviceAction.getTagReferenceListSuccess(tagReferenceSagaSuccess));
}

export default function* DeviceSaga() {
  yield (
    takeLatest(types.DEVICE_LIST, listDeviceSaga),
    takeLatest(types.CREATE_DEVICE, createDeviceSaga),
    takeLatest(types.UPDATE_DEVICE, updateDeviceSaga),
    takeLatest(types.DELETE_DEVICE, deleteDeviceSaga),
    takeLatest(types.DEVICE_LIST_CM, listDeviceCMSaga),
    takeLatest(types.GET_TAGREFERENCE_LIST, listTagReferenceSaga)
  );
}
